function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import LoginButton from "../login-button/LoginButton";
//eslint-disable-next-line
import { CORE_BUTTON_STYLES } from "../login-button/LoginButton";
const PortalButton = ({
  classes,
  children,
  buttonClasses,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(LoginButton, _extends({
    color: "secondary",
    loadingAnimaionColor: "secondary",
    buttonClasses: {
      containedSecondary: `${classes.portalButton} ${buttonClasses}`,
      outlinedSecondary: `${classes.outlinePortalButton} ${buttonClasses}`
    },
    containerClasses: classes.buttonContainer
  }, rest), children);
};
const styles = theme => ({
  portalButton: {
    backgroundColor: theme.palette.secondary.dark,
    ...CORE_BUTTON_STYLES,
    minWidth: "unset",
    height: 40,
    minHeight: 40,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#145DFF"
    },
    "&:focus": {
      cursor: "pointer",
      backgroundColor: "#1F64FF"
    }
  },
  outlinePortalButton: {
    borderColor: theme.palette.secondary.dark,
    ...CORE_BUTTON_STYLES,
    minWidth: "unset",
    height: 40,
    minHeight: 40,
    "&:hover": {
      cursor: "pointer",
      borderColor: theme.palette.secondary.light
    }
  },
  buttonContainer: {
    minWidth: "unset"
  }
});
export default withStyles(styles)(PortalButton);
PortalButton.propTypes = {
  classes: PropTypes.object.isRequired,
  buttonClasses: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]).isRequired
};